import Loaders from './Loaders';

export default Loaders;



// WEBPACK FOOTER //
// ./src/app/components/Loaders/index.js